module.exports = __webpack_public_path__ + "static/media/aqua3.c1bff5a5.jpg";